// Lightweight analytics helper.
// Fires a semantic event to Google Analytics 4 (gtag) from a single call site.
// Safe during SSR and when a user has opted out (gtag self-disables via the `ga-disable-*` flag).
export const trackEvent = (name, params = {}) => {
  if (typeof window === 'undefined') return
  if (typeof window.gtag === 'function') {
    window.gtag('event', name, params)
  }
}
